/** Delay so the new note is in sprint state before the full tidy runs. */
export const NOTE_ADD_TIDY_DELAY_MS = 50;

/**
 * Keep the camera on the host mission through the add-note tidy.
 * Follow must be armed before autoLayout so implicit ELK cannot steal the pan.
 */
export function scheduleNoteAddLayoutFollow(flowchartRef, hostTaskId) {
  if (!hostTaskId) return null;
  flowchartRef?.current?.followTaskAfterLayout?.(hostTaskId);
  return setTimeout(() => {
    flowchartRef?.current?.autoLayout?.(new Set());
  }, NOTE_ADD_TIDY_DELAY_MS);
}
